module.exports = __webpack_public_path__ + "static/media/EconomyPumpHHIncomeView.b856369e.jpg";